import React from 'react';
import Button from 'react-bootstrap/Button';

const GoogleAuthButton = ({
    onClick,
    disabled = false,
    text,
    className = "google-auth-btn",
    size = "lg"
}) => {
        // Validate required props
    if (!text) {
        console.error('GoogleAuthButton: text prop is required');
        return null;
    }

    return (
        <Button
            type="button"
            className={`btn btn-${size} ${className}`}
            onClick={onClick}
            disabled={disabled}
            variant="outline-light"
        >                                    
            <img
                src="https://developers.google.com/identity/images/g-logo.png"
                alt="Google logo"
                className="me-2"
                style={{ width: "20px", height: "20px" }}
            />
            {text}
        </Button>
    );
};

export default GoogleAuthButton;

